module.exports = __webpack_public_path__ + "static/homepage_image3-db0ad87702b98cd6fa320a0e3bfbd39b.png";